require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/generic.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/generic.legacy.js
// module id = 634
// module chunks = 31